import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Textarea = styled.textarea`
  width: 100%;
  font-size: 12px;
  font-family: inherit;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid ${colors.softGray};
  color: ${colors.titleStrongBlack};
  box-sizing: border-box;
  padding: 12px 12px 12px 16px;
  gap: 12px;
  vertical-align: baseline;
  resize: none;
  background-color: white;
  overflow:hidden;
  &:disabled {
    color: ${colors.strongGray};
  }

  @media(max-width: 550px) {
    font-size: 14px;
  }
`
